import { Routes } from '@angular/router';

// Components
import { TeamMemberListComponent } from './Components/team-member-list/team-member-list.component';
import { TeamMemberDetailComponent } from './Components/team-member-detail/team-member-detail.component';
import { TeamMemberAddComponent } from './Components/team-member-add/team-member-add.component';
import { TeamMemberEditComponent } from './Components/team-member-edit/team-member-edit.component';
import { TeamGSLComponent } from './Components/team-manage/team-gsl/team-gsl.component';

export const teamRoutes: Routes = [
    { path: 'teammembers', component: TeamMemberListComponent, data: { title: 'Our Team', icon: 'people_outline', primary: true }},
    { path: 'teammembers/add', component: TeamMemberAddComponent, data: { primary: false }},
    { path: 'teammembers/:id', component: TeamMemberDetailComponent, data: { primary: false }},
    { path: 'teammembers/edit/:id', component: TeamMemberEditComponent, data: { primary: false }},
    { path: 'team/gsl', component: TeamGSLComponent, data: { primary: false }}
];